import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router";

// import CSSModules from "lib/utils/css-modules"
import { st, SubBar, MainView, HintView, Button, AgentCooperationFullDecorator } from "lib/index";
import { addWindowOnBeforeUnloadCallback } from "modules/utils/index";
import { pushCompanyRoute } from "modules/app/actions";
import {
  stateSelector,
  initializeView,
  fetchAgentCooperation,
  updateModel,
  validate,
  submit,
  removeAgentCooperation,
} from "./index";
import Hint from "./EditAgentCooperationHint";
import EditAgentCooperationForm from "./EditAgentCooperationForm";
// import styles from "./EditAgentCooperationView.less"

@connect(
  (state) => ({
    currentCompanyId: state.auth.company.model.id,
    currentCompany: state.auth.company.model,
    coop: stateSelector(state).form.model,
    fetchDone: stateSelector(state).resource.fetchDone,
    fetchLoading: stateSelector(state).resource.fetchLoading,
    fetchFailed: stateSelector(state).resource.fetchFailed,
    dirty: stateSelector(state).form.dirty,
    valid: stateSelector(state).form.valid,
    errors: stateSelector(state).form.errors,
    submitLoading: stateSelector(state).form.submitLoading || stateSelector(state).removal.fetchLoading,
  }),
  (dispatch) =>
    bindActionCreators(
      {
        pushCompanyRoute,
        initializeView,
        fetchAgentCooperation,
        updateModel,
        validate,
        submit,
        removeAgentCooperation,
      },
      dispatch
    )
)
@withRouter
// @CSSModules(styles)
export default class EditAgentCooperationView extends React.PureComponent {
  subscriptions = [];

  componentDidMount() {
    this.props.initializeView({ coopId: +this.props.params.id });

    addWindowOnBeforeUnloadCallback(this, () => {
      const { dirty } = this.props;
      if (dirty) {
        return I18n.t("papp.common.discard_changes_confirm_message");
      }
    });
  }

  componentWillUnmount() {
    this.subscriptions.forEach((s) => s.unsubscribe());
    this.subscriptions.length = 0;
  }

  handleGoBackClick() {
    const { currentCompanyId, coop } = this.props;
    const coopCompanyType = coop && currentCompanyId === coop.agent.id ? "supplier" : "agent";
    this.props.pushCompanyRoute(coopCompanyType === "agent" ? "/agents" : "/suppliers");
  }

  handleRemoveClick() {
    st.confirm({
      content: I18n.t("papp.agents.EditAgentCooperationView.remove_confirm_message"),
    }).then((yes) => yes && this.props.removeAgentCooperation());
  }

  render() {
    const {
      currentCompanyId,
      currentCompany,
      coop,
      fetchDone,
      fetchLoading,
      fetchFailed,
      fetchAgentCooperation,
      valid,
      dirty,
      errors,
      submitLoading,
      updateModel,
      validate,
      submit,
      removeAgentCooperation,
    } = this.props;
    const coopCompanyType = coop && currentCompanyId === coop.agent.id ? "supplier" : "agent";
    const coopCompany = coop && coop[coopCompanyType];

    return (
      <MainView.Container>
        <SubBar>
          <div className="pull-left">
            <h1>
              {!coop && I18n.t("papp.agents.EditAgentCooperationView.title")}
              {coop &&
                I18n.t("papp.agents.EditAgentCooperationView.title_with_company_name", {
                  company_name: coopCompany.name,
                })}
            </h1>
          </div>

          <div className="pull-right">
            <Button
              as="a"
              basic
              className="u-marginLeft"
              content={I18n.t("papp.common.go_back")}
              onClick={this.handleGoBackClick.bind(this)}
            />
            <Button
              as="a"
              basic
              negative
              className="u-marginLeft"
              content={I18n.t("papp.common.remove")}
              disabled={submitLoading}
              onClick={this.handleRemoveClick.bind(this)}
            />
            <Button
              primary
              className="u-marginLeft"
              content={I18n.t("papp.common.save")}
              disabled={!dirty || submitLoading}
              onClick={() => submit()}
            />
          </div>
        </SubBar>
        <MainView.Content hasSubBar padded={false}>
          <MainView.Dimmer loading={fetchLoading} failed={fetchFailed} retry={fetchAgentCooperation} />
          {coop && (
            <HintView.Container>
              <HintView.Content>
                <EditAgentCooperationForm
                  {...{
                    currentCompanyId,
                    currentCompany,
                    coop,
                    valid,
                    errors,
                    submitLoading,
                    onChange: updateModel,
                    onBlur: validate,
                    onSubmit: submit,
                  }}
                />
              </HintView.Content>
              <HintView.Sidebar>
                <Hint coop={coop} />
              </HintView.Sidebar>
            </HintView.Container>
          )}
        </MainView.Content>
      </MainView.Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/agents/EditAgentCooperationView/EditAgentCooperationView.jsx